export const BRAND_NAME = 'Koç İnşaat Anonim Şirketi Proje Yönetim Sistemi';
export const BRAND_SHORT = 'Koç İnşaat A.Ş.';
